import { render, staticRenderFns } from "./team-setup.vue?vue&type=template&id=22e768b6"
import script from "./team-setup.ts?vue&type=script&lang=ts&external"
export * from "./team-setup.ts?vue&type=script&lang=ts&external"
import style0 from "./team-setup.vue?vue&type=style&index=0&id=22e768b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports